Util = require 'app/scripts/lib/util'
warnIfFileTooLarge = require 'app/scripts/views/internal/warn-if-file-too-large'
pastedFileName = require 'app/scripts/views/internal/pasted-file-name'
ninvoke = require 'app/scripts/lib/util/ninvoke'
Alerts = require 'app/scripts/views/lib/alerts'
Promise = require 'bluebird'

module.exports.dragenter = (e) ->
  if !@model.editable()
    return

  _height = @$el.outerHeight()

  limited = !@model.canAttach()
  restricted = !@model.canDropAttachment(e.type)
  className = if restricted
    '.list-card-dropzone-restricted'
  else if limited
    '.list-card-dropzone-limited'
  else
    '.list-card-dropzone'
  @$(className).css
    height: "#{_height}px"
    'line-height': "#{_height}px"

  @$el
  .addClass('is-drophover')
  .toggleClass('is-restricted', restricted)
  .toggleClass('is-limited', limited)

module.exports.dragleave = (e) ->
  @$el.removeClass('is-drophover')

module.exports.dropFiles = (e) ->
  if !@model.canAttach() || @model.attachmentTypeRestricted('computer')
    # Stop the event so we don't create a new card with the files
    Util.stop(e)
    return

  files = e.detail

  if warnIfFileTooLarge(@model.getBoard(), files)
    return

  Promise.resolve(files)
  .each (file) =>
    name = file.name || pastedFileName()
    ninvoke @model, 'upload', file, name
  .catch ->
    Alerts.show("unable to upload file", 'error', 'upload', 5000)
  .done()

  e.stopPropagation()

module.exports.dropUrl = (e) ->
  if !@model.canAttach() || @model.attachmentTypeRestricted('link')
    # Stop the event so we don't create a new card with the files
    Util.stop(e)
    return

  url = e.detail

  board = @model.getBoard()
  if board.attachmentUrlRestricted(url)
    return

  @model.uploadUrl url

  e.stopPropagation()
